import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { TenantService } from '../core/tenant.service';

/**
 * RegistrationGuard — Angular 17+ functional guard (CanActivateFn).
 *
 * Calls TenantService.loadTenant() to check if the authenticated user
 * has completed their tenant profile. If not registered (loadTenant returns null,
 * which happens on a 403 response), redirects to /registration.
 *
 * The result is cached by TenantService after the first successful call,
 * so subsequent navigations do not trigger additional network requests.
 *
 * Requirements: 5.1
 */
export const registrationGuard: CanActivateFn = () => {
  const tenantService = inject(TenantService);
  const router = inject(Router);

  return tenantService.loadTenant().pipe(
    map((tenant) => {
      if (tenant === null) {
        // No tenant record — registration not started.
        return router.createUrlTree(['/registration']);
      }
      if (!tenantService.hasChosenPlan(tenant)) {
        // Registered but no billing plan chosen — the setup wizard isn't
        // finished, so keep the user in the registration flow (on the payment
        // step) rather than letting them into the portal shell.
        return router.createUrlTree(['/registration'], { queryParams: { step: 'plan' } });
      }
      return true;
    })
  );
};
